<template>
  <div class="ovg-form">
    <p class="ovg-hint">
      Verifica que la información ingresada sea correcta antes de generar tu
      registro. Podrás modificar cualquier dato si lo necesitas.
    </p>

    <div class="ovg-summary">
      <h3 class="ovg-section-title">Datos del Cliente:</h3>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label ovg-summary__label--accent">R.U.T</p>
          <p class="ovg-summary__value">{{ datosCliente.rut }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Nombre</p>
          <p class="ovg-summary__value">{{ datosCliente.nombre }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Apellido</p>
          <p class="ovg-summary__value">{{ datosCliente.apellido }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Correo Electrónico</p>
          <p class="ovg-summary__value">{{ datosCliente.email }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Teléfono</p>
          <p class="ovg-summary__value">
            {{ datosCliente.telefono || '—' }}
          </p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Región</p>
          <p class="ovg-summary__value">{{ datosCliente.region }}</p>
        </div>
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Comuna</p>
          <p class="ovg-summary__value">{{ datosCliente.comuna }}</p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item ovg-summary__item--full">
          <p class="ovg-summary__label">Dirección de la Calle</p>
          <p class="ovg-summary__value">{{ datosCliente.direccion }}</p>
        </div>
      </div>
    </div>

    <div class="ovg-summary">
      <h3 class="ovg-section-title">Datos de la Falla:</h3>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Tipo de Servicio</p>
          <p class="ovg-summary__value">
            {{ garantiaFalla.tipo_servicio === 1 ? 'Garantía' : 'Presupuesto' }}
          </p>
        </div>
      </div>

      <div
        v-if="
          garantiaFalla.tipo_servicio === 1 && garantiaFalla.fecha_de_compra
        "
        class="ovg-summary__row"
      >
        <div class="ovg-summary__item">
          <p class="ovg-summary__label">Fecha de Compra</p>
          <p class="ovg-summary__value">
            {{ getFecha(garantiaFalla.fecha_de_compra) }}
          </p>
        </div>
      </div>

      <div class="ovg-summary__row">
        <div class="ovg-summary__item ovg-summary__item--full">
          <p class="ovg-summary__label">Descripción del Problema</p>
          <p class="ovg-summary__value">
            {{
              garantiaFalla.reporte_falla_cliente
                ? garantiaFalla.reporte_falla_cliente
                : '—'
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="ovg-card__footer ovg-card__footer--between">
      <button type="button" class="ovg-btn ovg-btn--secondary" @click="goBack">
        Paso Anterior
      </button>
      <button
        type="button"
        class="ovg-btn ovg-btn--primary"
        :disabled="loading"
        @click="guardar"
      >
        Confirmar Pre-Ingreso
      </button>
    </div>

    <div v-if="showModal" class="ovg-modal-backdrop" @click.self="finish">
      <div class="ovg-modal" role="dialog" aria-modal="true">
        <div class="ovg-modal__header">
          <h3 class="ovg-modal__title">¡Pre-ingreso registrado con éxito!</h3>
          <button
            type="button"
            class="ovg-modal__close"
            aria-label="Cerrar"
            @click="finish"
          >
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <font-awesome-icon class="ovg-modal__icon" icon="check-circle" />
        <p class="ovg-modal__text">
          Te hemos enviado un correo con el resumen.<br />
          Ya puedes acercarte a nuestra sucursal con tu equipo para finalizar la
          recepción sin hacer filas extra.
        </p>
        <button type="button" class="ovg-btn ovg-btn--primary" @click="finish">
          Volver al inicio
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'Resumen',
  props: ['datosCliente', 'garantiaFalla', 'boleta'],
  data() {
    return {
      showModal: false,
      responseMsj: '',
      responseOk: true,
      loading: false,
    }
  },
  methods: {
    ...mapActions('PreIngreso', ['sendPreIngreso']),
    goBack() {
      this.$emit('goBack')
    },
    getFecha(fecha) {
      return moment(fecha).format('DD-MM-YYYY')
    },
    async guardar() {
      this.loading = true
      const otData = {
        datos_provisorios: this.datosCliente,
        ...this.garantiaFalla,
      }
      const formData = new FormData()
      formData.append('ot_data', JSON.stringify(otData))
      formData.append('boleta', this.boleta)
      const response = await this.sendPreIngreso(formData)
      this.showModal = true
      this.responseMsj = response.data
      this.responseOk = response.status === 201
      this.loading = false
    },
    finish() {
      this.$emit('finish')
      this.showModal = false
    },
  },
}
</script>
